import { trace } from 'rytm-helpers'
import Controller from './Controller'

class ReCaptchaController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
  }
  addEventListeners() {
    super.addEventListeners()
    this.initReCaptcha()
  }
  removeEventListeners() {
    super.removeEventListeners()
  }
  /**
   * ###########
   * ### OWN ###
   */
  initReCaptcha() {
    const container = document.querySelector(this.getContainerSelector())
    const form = container.querySelector("form")
    const key = container ? container.dataset.recaptchaKey : null
    const recaptchaId = container ? container.dataset.recaptchaId : null
    if (form && key && recaptchaId) {
      // create INPUT hidden...
      const reCaptchaInput = document.createElement("input")
      reCaptchaInput.type = "hidden"
      reCaptchaInput.name = recaptchaId
      // on recaptcha executed
      function onExecuted(token) {
        // set token
        reCaptchaInput.value = token;
        // append to form
        form.appendChild(reCaptchaInput);
        form.submit();
        form.classList.add("loading")
      }
      // on submitted
      function onSubmitted(e) {
        e.preventDefault();
        grecaptcha.execute(key, { action: 'submit' }).then(onExecuted);
      }
      form.addEventListener("submit", onSubmitted, false)
    }
  }

}

export default ReCaptchaController;